export const menuData = [
  {
    label: 'Home',
    url: '/'
  },
  {
    label: 'Map Legend',
    url: '#'
  },
  {
    label: 'About',
    url: '/about'
  },
  {
    label: 'Contact',
    url: '#'
  }
];
